import request from './request';
import config from './config';

export const apiUrl = path => `${config.url}api/${path}`;

export function guestHeaders() {
    return {
        'agent': localStorage.getItem('agentCode'),
        'Content-Type': 'application/json'
    };
}

export function authHeaders() {
    return {
        Authorization: `Bearer ${localStorage.getItem('gamingToken') || ''}`,
        'Content-Type': 'application/json'
    };
}

export function formHeaders() {
    return {
        Authorization: `Bearer ${localStorage.getItem('gamingToken') || ''}`,
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'multipart/form-data'
    };
}

export { request, config };
